module.exports = __webpack_public_path__ + "img/ping_h5.9f995667.png";